import { render } from "./IconToday.vue?vue&type=template&id=24406da9"
import script from "./IconToday.vue?vue&type=script&lang=js"
export * from "./IconToday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__